import { z } from "zod";

import { dateTimeFormatSchema } from "./enums";

export const convertDatetimeConfigurationSchema = z.object({
	sourceField: z.string(),
	targetField: z.string(),
	format: dateTimeFormatSchema,
	culture: z.string(),
	timezone: z.string(),
});
